import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { StatementsFacade } from '@app/modules/businesses/services/statements.facade';
import { UpsellService } from '@app/shared/+state/shared/upsell.service';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { UsersFacade } from '@app/shared/+state/users';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
@Component({
  selector: 'sbnb-accounting-upsell',
  standalone: false,
  templateUrl: './accounting-upsell.component.html',
  styles: `
    section::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('/assets/images/owner-statements/accounting-upsell-background.png');
      background-size: contain;
      background-repeat: no-repeat;
      opacity: 0.4;
      z-index: 1;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountingUpsellComponent {
  #upsellService = inject(UpsellService);
  #statementsFacade = inject(StatementsFacade);
  #userPermissionsService = inject(UserPermissionsService);

  public showAccounting$ = this.#upsellService.accountingEnabled$;

  public showMogulUpgrade$ = combineLatest([
    this.#statementsFacade.ownerStatementEntitlement$,
    this.#userPermissionsService.isPrimaryUser(),
  ]).pipe(map(([entitlement, isPrimary]) => isPrimary && (!entitlement.available || !entitlement.unlimited)));

  scheduleCall() {
    this.#upsellService.contactSalesForMogul('StatementsAccounting');
  }

  upgradeToMogul() {
    this.#upsellService.redirectToPlans();
  }
}
